/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

app.controller('dialog_addPermissionToGroupCtrl', ['$scope', '$http', 'NetworkService', 'MainService', 'IntentService', function ($scope, $http, NetworkService, MainService, IntentService) {

        $scope.events = []
        $scope.showSuggests = false
        $scope.createGroup = function ()
        {
            var persons = IntentService.emitEvent("getGroupMembers")
            var groupName = $scope.groupname
            var groupDescr = $scope.groupdescr
            NetworkService.addGroup(groupName, groupDescr, function (data) {
                var id = data.position_id
                console.log(persons)
                persons.forEach(function (el) {
                    NetworkService.addPersonToGroup(el.email, id)
                })
            })

        }
        
        $scope.setSuggest = function(eventname, veranstaltung_id)
        {
            $scope.eventName = eventname;
            $scope.showSuggests = false;
            $scope.veranstaltung_id = veranstaltung_id
        }
        
        $scope.addPermission = function()
        {
            var groupId = MainService.getDialogData("dialog_addPermissionToGroupCtrl").groupId
            console.log("addin groupd: |"+groupId+"|")
            NetworkService.addPermission(groupId, $scope.veranstaltung_id, $scope.permission, function(data){
                console.log(data)
            })
        }
        
        NetworkService.getEvents(function(data){
            $scope.events = data
        })
        
        $(document).ready(function () {
            // Select - Single
            $('select:not([multiple])').material_select();
        });
    }])
